import { SVGProps } from 'react';

const SvgFileCircleQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M384 160 224 0v128c0 17.7 14.3 32 32 32h128zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-94.4c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9 0 17.1-9.5 32.7-24.5 40.6L448 378.9v5.1c0 8.8-7.2 16-16 16s-16-7.2-16-16v-14.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3 0-7.7-6.2-13.9-13.9-13.9h-40.5c-5.3 0-9.6 4.3-9.6 9.6v6.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.4z"
      className="file-circle-question_svg__fa-primary"
    />
    <path
      d="M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v38.6c-73.9 20.9-128 88.8-128 169.4 0 59.1 29.1 111.3 73.7 143.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64z"
      style={{
        opacity: 0.4,
      }}
    />
  </svg>
);
export default SvgFileCircleQuestion;
